import {hndlr, Q} from './util'
import 'crel'
import {waiting_modal} from "./waiting_modal";

/**
 * Form handling for creadit card vaulting
 */
(() => {
    document.addEventListener('DOMContentLoaded', async () => {

        var form = document.querySelector('#hosted-fields-form');
        var submit = document.querySelector('#hosted-fields-form input[type="submit"]');
        if (!form) return // We stop processing if we are not on the right page

        let client_instance = braintree.client.create({authorization: bt_tokenization_key})
        var [client_instance_resolve, err] = await hndlr(client_instance)
        if (err) {
            console.error(err);
            alert('Prišlo je do napake pri ustvarjanju Braintree povezave');
            return
        }

        let hosted_fields_instance = braintree.hostedFields.create({
            client: client_instance_resolve,
            // Customize the Hosted Fields.
            // More information can be found at:
            // https://developers.braintreepayments.com/guides/hosted-fields/styling/javascript/v3
            styles: {
                'input': {
                    'font-size': '1em',
                    'font-family': 'roboto, verdana, sans-serif',
                    // 'font-weight': 'lighter',
                    'color': 'black'
                },
                'input.invalid': {
                    'color': 'red'
                },
                'input.valid': {
                    'color': 'green'
                }
            },
            // Configure which fields in your card form will be generated by Hosted Fields instead
            fields: {
                number: {
                    container: '#card-number',
                    placeholder: '4111 1111 1111 1111'
                },
                cvv: {
                    container: '#cvv',
                    placeholder: '123'
                },
                expirationDate: {
                    container: '#expiration-date',
                    placeholder: '10/2022'
                }
            }
        })

        var [hosted_fields_instance_resolve, err] = await hndlr(hosted_fields_instance)
        if (err) {
            console.error(err);
            alert('Prišlo je do napake ustvarjanju formularja');
            return
        }

        // Once the fields are initialized enable the submit button
        submit.removeAttribute('disabled');

        form.addEventListener('submit', async e => {
            e.preventDefault()
            let payload = hosted_fields_instance_resolve.tokenize()

            var [payload_resolve, err] = await hndlr(payload)
            if (err) {
                console.error(err);
                alert('Prišlo je do napake pri tokenizaciji');
                return
            }

            // create_modal(form, payload_resolve)
            waiting_modal('Dodajamo plačilno metodo...')
            location = (`/store/payment/methods/vault/${payload_resolve.nonce}`)
        })


        // Delete payment method modal
        ;document.querySelectorAll('.bt_delete_card_from_vault').forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault()
                let close, brisi
                if(Q('#modalDelete')) Q('#modalDelete').remove()
                let modal = crel('div', {id: 'modalDelete', class: 'modal'},
                    crel('div', {class: 'modal-content'},
                        crel('h4', 'Pozor!'),
                        crel('p', 'Ste prepričani, da želite izbrisati plačilno sredstvo?')
                    ),
                    crel('div', {class: 'modal-footer'},
                        brisi = crel('a', {class: 'waves-effect waves-light blue darken-3 btn', style: 'margin-right:0.3em;'}, 'Briši'),
                        close = crel('a', {class: 'modal-close waves-effect waves-light btn'}, 'Prekliči'),
                    )
                )
                crel(el.parentNode, modal)
                let [m, c, b] = [modal, close, brisi].map(e => M.Modal.init(e))
                m.open()

                brisi.addEventListener('click', ee => {
                    ee.preventDefault()
                    waiting_modal('Kontaktiramo plačilnega ponudnika...') // imported in app.js
                    location = el.href
                })
            })
        })

    })

})();

(()=>{
    document.addEventListener('DOMContentLoaded', async ()=> {
        if(!window.braintree || !window.braintree.client) return

        const clientInstance = await braintree.client.create({
            authorization: bt_tokenization_key
        });
        const pPCheckout = await braintree.paypalCheckout.create({
            client: await clientInstance
        });
        pPCheckout.loadPayPalSDK({
          vault: true
        }, err => {
            if(err) {
                alert(err)
                return
            }
            paypal.Buttons({
                fundingSource: paypal.FUNDING.PAYPAL,
                createBillingAgreement() {
                    return pPCheckout.createPayment({
                        flow: 'vault'
                    })
                },
                onApprove(data, actions) {
                    return pPCheckout.tokenizePayment(data, (err, payload) => {
                        waiting_modal('Kontaktiramo plačilnega ponudnika...') // imported in app.js
                        location = (`/store/payment/methods/vault/${payload.nonce}`)
                    });
                },
                onCancel(data) {
                    console.log('PayPal payment canceled', JSON.stringify(data, 0, 2));
                },
                onError(err) {
                    console.error('PayPal error', err);
                },
                style: {
                    layout: 'vertical',
                    color: 'blue',
                    shape: 'rect',
                    label: 'paypal'
                }
            }).render('#paypal-button');
        })

    })
})();

/**
 * Subscriptions handling
 */

document.addEventListener('DOMContentLoaded', async () => {
    /**
     * Change payment method on subscription
     */
    const change_payment_method = (el) => {
        let add, close
        let modal = crel('div', {id: 'modalDelete', class: 'modal'},
            crel('div', {class: 'modal-content'},
                crel('h4', 'Menjava plačilnega sredstva'),
                crel('p', 'Ste prepričani, da želite zamenjati plačilno sredstvo?')
            ),
            crel('div', {class: 'modal-footer'},
                add = crel('a', {class: 'waves-effect waves-light blue darken-3 btn', style: 'margin-right:0.3em;'}, 'Shrani'),
                close = crel('a', {class: 'modal-close waves-effect waves-light btn'}, 'Prekliči'),
            )
        )
        crel(el.parentNode.parentNode.parentNode, modal)
        let [m, c, b] = [modal, close, add].map(e => M.Modal.init(e))
        m.open()

        add.addEventListener('click', ee => {
            ee.preventDefault()
            waiting_modal('Kontaktiramo plačilnega ponudnika...') // imported in app.js
            location = el.href
        })
    }

    const cancel_subscription = (el) => {
        let close, brisi
        if(Q('#modalDelete')) Q('#modalDelete').remove()
        let modal = crel('div', {id: 'modalDelete', class: 'modal'},
            crel('div', {class: 'modal-content'},
                crel('h4', 'Pozor!'),
                crel('p', 'Ste prepričani, da želite prekiniti naročnino?')
            ),
            crel('div', {class: 'modal-footer'},
                brisi = crel('a', {class: 'waves-effect waves-light blue darken-3 btn', style: 'margin-right:0.3em;'}, 'Prekini'),
                close = crel('a', {class: 'modal-close waves-effect waves-light btn'}, 'Prekliči'),
            )
        )
        crel(el.parentNode, modal)
        let [m, c, b] = [modal, close, brisi].map(e => M.Modal.init(e))
        m.open()

        brisi.addEventListener('click', ee => {
            ee.preventDefault()
            waiting_modal('Kontaktiramo plačilnega ponudnika...') // imported in app.js
            location = el.href
        })
    }


    /* Change */
    ;document.querySelectorAll('.bt_change_payment_method').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault()
            change_payment_method(el)
        })
    })
    /* Cancel */
    ;document.querySelectorAll('.bt_cancel_subscription').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault()
            cancel_subscription(el)
        })
    })
})